import { Action, initialState, State } from 'store/store';

export const moduleWasManuallySetComplete = (
  state: State = initialState,
  { data }: Action
): State => {
  //
  // console.log('moduleWasManuallySetComplete :', data);

  const nextState = {
    ...state,
    moduleWasManuallySetComplete: data as any,
  };

  return nextState;
};
